import { render, staticRenderFns } from "./CallbackComponent.vue?vue&type=template&id=8ae884a6"
import script from "./CallbackComponent.vue?vue&type=script&lang=js"
export * from "./CallbackComponent.vue?vue&type=script&lang=js"
import style0 from "./CallbackComponent.vue?vue&type=style&index=0&id=8ae884a6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports